<span *ngIf="holding.isPrivate && isViewingAsInvestor" class="private">
  <mat-icon class="material-icons" svgIcon="visibility_lock"></mat-icon>
  This {{holdingTypeStr}} is not visible to your investors
</span>
